export default __webpack_public_path__ + "static/media/coronal-square.c514ec07.png";